// extracted by mini-css-extract-plugin
export default {"captcha":"captcha-kIwcfQ","content":"content-njx_1z"};